// test764
(764 && 0);
